import { render } from "./VentaForm.vue?vue&type=template&id=a49680f0"
import script from "./VentaForm.vue?vue&type=script&lang=js"
export * from "./VentaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__